import { motion } from "framer-motion";

const stages = [
  "Logs",
  "Metrics",
  "Traces",
  "Packets",
  "AI Correlation Engine",
  "Decision",
  "Automated Action",
];

export function HeroPipeline() {
  const points = [
    { x: 40, y: 70 },
    { x: 160, y: 52 },
    { x: 290, y: 74 },
    { x: 420, y: 56 },
    { x: 565, y: 78 },
    { x: 705, y: 52 },
    { x: 850, y: 72 },
  ];

  return (
    <div className="relative h-[280px] w-full">
      <div
        className="absolute inset-0 rounded-3xl"
        style={{
          background:
            "radial-gradient(600px 220px at 30% 40%, rgba(0,212,255,0.18), transparent 60%), radial-gradient(520px 240px at 80% 60%, rgba(99,102,241,0.16), transparent 60%)",
        }}
      />
      <svg
        viewBox="0 0 900 150"
        className="absolute inset-0 h-full w-full"
        role="img"
        aria-label="Telemetry pipeline: Logs to automated action"
      >
        <defs>
          <linearGradient id="flow" x1="0" x2="1">
            <stop offset="0" stopColor="#00d4ff" stopOpacity="0.25" />
            <stop offset="0.5" stopColor="#00d4ff" stopOpacity="0.9" />
            <stop offset="1" stopColor="#10b981" stopOpacity="0.35" />
          </linearGradient>
          <filter id="glow" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur stdDeviation="4" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <path
          d={`M ${points[0].x} ${points[0].y} C 120 12, 210 128, ${points[2].x} ${points[2].y} S 500 10, ${points[4].x} ${points[4].y} S 730 120, ${points[6].x} ${points[6].y}`}
          stroke="url(#flow)"
          strokeWidth="2"
          fill="none"
          opacity="0.9"
        />
        <path
          d={`M ${points[0].x} ${points[0].y} C 120 12, 210 128, ${points[2].x} ${points[2].y} S 500 10, ${points[4].x} ${points[4].y} S 730 120, ${points[6].x} ${points[6].y}`}
          stroke="#00d4ff"
          strokeWidth="6"
          fill="none"
          opacity="0.08"
        />

        {points.map((p, idx) => (
          <g key={`${p.x}-${p.y}`}
            filter="url(#glow)"
          >
            <circle cx={p.x} cy={p.y} r={idx === 4 ? 9 : 7} fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" />
            <motion.circle
              cx={p.x}
              cy={p.y}
              r={idx === 4 ? 4 : 3}
              fill={idx === 4 ? "#10b981" : "#00d4ff"}
              animate={{ opacity: [0.35, 1, 0.35] }}
              transition={{ duration: 2.2, repeat: Infinity, delay: idx * 0.12 }}
            />
          </g>
        ))}

        <motion.circle
          r="3.5"
          fill="#00d4ff"
          filter="url(#glow)"
          animate={{
            cx: [40, 160, 290, 420, 565, 705, 850],
            cy: [70, 52, 74, 56, 78, 52, 72],
            opacity: [0.2, 1, 1, 1, 1, 1, 0.2],
          }}
          transition={{ duration: 4.8, ease: "linear", repeat: Infinity }}
        />
        <motion.circle
          r="2.5"
          fill="#10b981"
          filter="url(#glow)"
          animate={{
            cx: [40, 160, 290, 420, 565, 705, 850],
            cy: [70, 52, 74, 56, 78, 52, 72],
            opacity: [0.1, 0.8, 0.9, 0.9, 0.9, 0.9, 0.1],
          }}
          transition={{ duration: 4.8, ease: "linear", repeat: Infinity, delay: 1.2 }}
        />
      </svg>

      <div className="absolute inset-x-0 bottom-0 grid grid-cols-2 gap-2 px-4 pb-4 sm:grid-cols-4 lg:grid-cols-7">
        {stages.map((s, idx) => (
          <div
            key={s}
            className={`rounded-2xl border border-white/10 bg-white/3 px-3 py-2 text-center text-[11px] leading-tight text-[var(--text-secondary)] ${
              idx === 4 ? "text-white border-[rgba(16,185,129,0.35)]" : ""
            }`}
          >
            {s}
          </div>
        ))}
      </div>
    </div>
  );
}
